'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Input = require('../../../components/Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AmountItem = function (_Component) {
  _inherits(AmountItem, _Component);

  function AmountItem(props) {
    _classCallCheck(this, AmountItem);

    var _this = _possibleConstructorReturn(this, (AmountItem.__proto__ || Object.getPrototypeOf(AmountItem)).call(this, props));

    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.defaultValue !== _this.props.defaultValue) _this.setState({ value: _this.props.defaultValue });
    };

    _this.state = { value: props.defaultValue };
    return _this;
  }

  _createClass(AmountItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          timespan = _props.timespan,
          currency = _props.currency,
          error = _props.error,
          _onChange = _props.onChange,
          initialStepValue = _props.initialStepValue;
      var value = this.state.value;


      return _react2.default.createElement(
        'div',
        { className: 'AmountItem custom-amount' },
        _react2.default.createElement(
          'button',
          {
            tabIndex: '1',
            className: 'button secondary custom-amount-decrement',
            type: 'button',
            onClick: function onClick() {
              return _this2.setState({ value: value ? Math.floor(value / 2) : 0 }, function () {
                return _onChange({ target: { name: timespan, value: _this2.state.value } });
              });
            },
            disabled: value <= 1 || !value },
          '-'
        ),
        _react2.default.createElement(_Input2.default, {
          className: 'custom-amount-input',
          onChange: function onChange(e) {
            _this2.setState({ value: e.target.value || 0 });
            _onChange && _onChange(e);
          },
          name: timespan,
          value: value,
          status: !!error && 'failure',
          statusText: error,
          currency: currency,
          type: 'number',
          inputMode: 'numeric',
          pattern: '[0-9]*',
          tabIndex: '0',
          min: '1',
          max: '99999999'
        }),
        _react2.default.createElement(
          'button',
          {
            tabIndex: '1',
            className: 'button secondary custom-amount-increment',
            type: 'button',
            onClick: function onClick() {
              return _this2.setState({ value: value ? Math.ceil(value * 2) : initialStepValue }, function () {
                return _onChange({
                  target: { name: timespan, value: _this2.state.value }
                });
              });
            } },
          '+'
        )
      );
    }
  }]);

  return AmountItem;
}(_react.Component);

exports.default = AmountItem;